import React from "react";
import { Collapse } from "reactstrap";
import { PathwayCard, PathwayCardBody } from "../PathwayCard";

const TabContentCard = ({ tabList, index, activeTab, tabPropertyName, children, useCollapse = true }) => {
    return (
        <div>
            <Collapse isOpen={useCollapse ? activeTab === tabList[index][tabPropertyName] : true}>
                <PathwayCard style={{ margin: 0 }}>
                    <PathwayCardBody>{children}</PathwayCardBody>
                </PathwayCard>
            </Collapse>
        </div>
    );
};

export default TabContentCard;
